// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SlugRouteImport } from './routes/$slug'
import { Route as AtivandoDoacaoRouteImport } from './routes/ativando-doacao'
import { Route as BlogNewsRouteImport } from './routes/blog-news'
import { Route as CadastroRouteImport } from './routes/cadastro'
import { Route as ComoFuncionaRouteImport } from './routes/como-funciona'
import { Route as ComoGeramosRouteImport } from './routes/como-geramos'
import { Route as CompletarPerfilRouteImport } from './routes/completar-perfil'
import { Route as ContatoRouteImport } from './routes/contato'
import { Route as CuponsDeDescontoRouteImport } from './routes/cupons-de-desconto'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as EntrarParaAvaliarRouteImport } from './routes/entrar-para-avaliar'
import { Route as EntrarParaDoarRouteImport } from './routes/entrar-para-doar'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PerfilRouteImport } from './routes/perfil'
import { Route as PrivacidadeRouteImport } from './routes/privacidade'
import { Route as RecuperarSenhaRouteImport } from './routes/recuperar-senha'
import { Route as RedefinirSenhaRouteImport } from './routes/redefinir-senha'
import { Route as SejaParceiroRouteImport } from './routes/seja-parceiro'
import { Route as SejaUmaMarcaDoBemRouteImport } from './routes/seja-uma-marca-do-bem'
import { Route as SobreNosRouteImport } from './routes/sobre-nos'
import { Route as TermosRouteImport } from './routes/termos'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminAiRouteRouteImport } from './routes/admin/ai/route'
import { Route as AdminBlogRouteImport } from './routes/admin/blog'
import { Route as AdminCategoriasRouteImport } from './routes/admin/categorias'
import { Route as AdminComparadorRouteImport } from './routes/admin/comparador'
import { Route as AdminCuponsRouteImport } from './routes/admin/cupons'
import { Route as AdminDisparosRouteImport } from './routes/admin/disparos'
import { Route as AdminDoacoesRouteImport } from './routes/admin/doacoes'
import { Route as AdminInstituicoesRouteImport } from './routes/admin/instituicoes'
import { Route as AdminIntegracoesRouteImport } from './routes/admin/integracoes'
import { Route as AdminLocalizacaoRouteImport } from './routes/admin/localizacao'
import { Route as AdminLocalizationRouteImport } from './routes/admin/localization'
import { Route as AdminMarketingRouteRouteImport } from './routes/admin/marketing/route'
import { Route as AdminSaudeRouteImport } from './routes/admin/saude'
import { Route as AdminSeoRouteImport } from './routes/admin/seo'
import { Route as AdminSyncRouteImport } from './routes/admin/sync'
import { Route as AdminTelemetriaRouteImport } from './routes/admin/telemetria'
import { Route as AdminTransacoesRouteImport } from './routes/admin/transacoes'
import { Route as AdminUsuariosRouteImport } from './routes/admin/usuarios'
import { Route as CausaSlugRouteImport } from './routes/causa/$slug'
import { Route as CausasIndexRouteImport } from './routes/causas/index'
import { Route as CausasTrocarRouteImport } from './routes/causas/trocar'
import { Route as ComparadorDePrecosIndexRouteImport } from './routes/comparador-de-precos/index'
import { Route as ComparadorDePrecosIdRouteImport } from './routes/comparador-de-precos/$id'
import { Route as MarcaSlugRouteImport } from './routes/marca/$slug'
import { Route as MarcasIndexRouteImport } from './routes/marcas/index'
import { Route as MarcasCategorySlugRouteImport } from './routes/marcas/$categorySlug'
import { Route as OfertasIndexRouteImport } from './routes/ofertas/index'
import { Route as OfertasBuscaRouteImport } from './routes/ofertas/busca'
import { Route as ProdutoSlugRouteImport } from './routes/produto/$slug'
import { Route as PromocoesSlugRouteImport } from './routes/promocoes/$slug'
import { Route as AdminAiIndexRouteImport } from './routes/admin/ai/index'
import { Route as AdminAiSophiaRouteImport } from './routes/admin/ai/sophia'
import { Route as AdminInternacionalIndexRouteImport } from './routes/admin/internacional/index'
import { Route as AdminInternacionalLojasRouteImport } from './routes/admin/internacional/lojas'
import { Route as AdminInternacionalPaisesRouteImport } from './routes/admin/internacional/paises'
import { Route as AdminInternacionalTraducoesRouteImport } from './routes/admin/internacional/traducoes'
import { Route as AdminLojasIndexRouteImport } from './routes/admin/lojas/index'
import { Route as AdminLojasBrandIdRouteImport } from './routes/admin/lojas/$brandId'
import { Route as AdminMarketingIndexRouteImport } from './routes/admin/marketing/index'
import { Route as AdminMarketingAutomacoesRouteImport } from './routes/admin/marketing/automacoes'
import { Route as AdminMarketingBannersRouteImport } from './routes/admin/marketing/banners'
import { Route as AdminMarketingCarrosselRouteImport } from './routes/admin/marketing/carrossel'
import { Route as AdminMarketingNewsletterRouteImport } from './routes/admin/marketing/newsletter'
import { Route as AdminMarketingNotificacoesRouteImport } from './routes/admin/marketing/notificacoes'
import { Route as AdminMarketingSeloRouteImport } from './routes/admin/marketing/selo'
import { Route as AdminMarketingWhatsappRouteImport } from './routes/admin/marketing/whatsapp'
import { Route as OfertasCategoriaIndexRouteImport } from './routes/ofertas/$categoria/index'
import { Route as OfertasCategoriaSubIndexRouteImport } from './routes/ofertas/$categoria/$sub/index'
import { Route as OfertasCategoriaSubPublicoRouteImport } from './routes/ofertas/$categoria/$sub/$publico'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SlugRoute = SlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => rootRouteImport
          })
const AtivandoDoacaoRoute = AtivandoDoacaoRouteImport.update({
            id: '/ativando-doacao',path: '/ativando-doacao',getParentRoute: () => rootRouteImport
          })
const BlogNewsRoute = BlogNewsRouteImport.update({
            id: '/blog-news',path: '/blog-news',getParentRoute: () => rootRouteImport
          })
const CadastroRoute = CadastroRouteImport.update({
            id: '/cadastro',path: '/cadastro',getParentRoute: () => rootRouteImport
          })
const ComoFuncionaRoute = ComoFuncionaRouteImport.update({
            id: '/como-funciona',path: '/como-funciona',getParentRoute: () => rootRouteImport
          })
const ComoGeramosRoute = ComoGeramosRouteImport.update({
            id: '/como-geramos',path: '/como-geramos',getParentRoute: () => rootRouteImport
          })
const CompletarPerfilRoute = CompletarPerfilRouteImport.update({
            id: '/completar-perfil',path: '/completar-perfil',getParentRoute: () => rootRouteImport
          })
const ContatoRoute = ContatoRouteImport.update({
            id: '/contato',path: '/contato',getParentRoute: () => rootRouteImport
          })
const CuponsDeDescontoRoute = CuponsDeDescontoRouteImport.update({
            id: '/cupons-de-desconto',path: '/cupons-de-desconto',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const EntrarParaAvaliarRoute = EntrarParaAvaliarRouteImport.update({
            id: '/entrar-para-avaliar',path: '/entrar-para-avaliar',getParentRoute: () => rootRouteImport
          })
const EntrarParaDoarRoute = EntrarParaDoarRouteImport.update({
            id: '/entrar-para-doar',path: '/entrar-para-doar',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const PerfilRoute = PerfilRouteImport.update({
            id: '/perfil',path: '/perfil',getParentRoute: () => rootRouteImport
          })
const PrivacidadeRoute = PrivacidadeRouteImport.update({
            id: '/privacidade',path: '/privacidade',getParentRoute: () => rootRouteImport
          })
const RecuperarSenhaRoute = RecuperarSenhaRouteImport.update({
            id: '/recuperar-senha',path: '/recuperar-senha',getParentRoute: () => rootRouteImport
          })
const RedefinirSenhaRoute = RedefinirSenhaRouteImport.update({
            id: '/redefinir-senha',path: '/redefinir-senha',getParentRoute: () => rootRouteImport
          })
const SejaParceiroRoute = SejaParceiroRouteImport.update({
            id: '/seja-parceiro',path: '/seja-parceiro',getParentRoute: () => rootRouteImport
          })
const SejaUmaMarcaDoBemRoute = SejaUmaMarcaDoBemRouteImport.update({
            id: '/seja-uma-marca-do-bem',path: '/seja-uma-marca-do-bem',getParentRoute: () => rootRouteImport
          })
const SobreNosRoute = SobreNosRouteImport.update({
            id: '/sobre-nos',path: '/sobre-nos',getParentRoute: () => rootRouteImport
          })
const TermosRoute = TermosRouteImport.update({
            id: '/termos',path: '/termos',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => rootRouteImport
          })
const AdminAiRouteRoute = AdminAiRouteRouteImport.update({
            id: '/admin/ai',path: '/admin/ai',getParentRoute: () => rootRouteImport
          })
const AdminBlogRoute = AdminBlogRouteImport.update({
            id: '/admin/blog',path: '/admin/blog',getParentRoute: () => rootRouteImport
          })
const AdminCategoriasRoute = AdminCategoriasRouteImport.update({
            id: '/admin/categorias',path: '/admin/categorias',getParentRoute: () => rootRouteImport
          })
const AdminComparadorRoute = AdminComparadorRouteImport.update({
            id: '/admin/comparador',path: '/admin/comparador',getParentRoute: () => rootRouteImport
          })
const AdminCuponsRoute = AdminCuponsRouteImport.update({
            id: '/admin/cupons',path: '/admin/cupons',getParentRoute: () => rootRouteImport
          })
const AdminDisparosRoute = AdminDisparosRouteImport.update({
            id: '/admin/disparos',path: '/admin/disparos',getParentRoute: () => rootRouteImport
          })
const AdminDoacoesRoute = AdminDoacoesRouteImport.update({
            id: '/admin/doacoes',path: '/admin/doacoes',getParentRoute: () => rootRouteImport
          })
const AdminInstituicoesRoute = AdminInstituicoesRouteImport.update({
            id: '/admin/instituicoes',path: '/admin/instituicoes',getParentRoute: () => rootRouteImport
          })
const AdminIntegracoesRoute = AdminIntegracoesRouteImport.update({
            id: '/admin/integracoes',path: '/admin/integracoes',getParentRoute: () => rootRouteImport
          })
const AdminLocalizacaoRoute = AdminLocalizacaoRouteImport.update({
            id: '/admin/localizacao',path: '/admin/localizacao',getParentRoute: () => rootRouteImport
          })
const AdminLocalizationRoute = AdminLocalizationRouteImport.update({
            id: '/admin/localization',path: '/admin/localization',getParentRoute: () => rootRouteImport
          })
const AdminMarketingRouteRoute = AdminMarketingRouteRouteImport.update({
            id: '/admin/marketing',path: '/admin/marketing',getParentRoute: () => rootRouteImport
          })
const AdminSaudeRoute = AdminSaudeRouteImport.update({
            id: '/admin/saude',path: '/admin/saude',getParentRoute: () => rootRouteImport
          })
const AdminSeoRoute = AdminSeoRouteImport.update({
            id: '/admin/seo',path: '/admin/seo',getParentRoute: () => rootRouteImport
          })
const AdminSyncRoute = AdminSyncRouteImport.update({
            id: '/admin/sync',path: '/admin/sync',getParentRoute: () => rootRouteImport
          })
const AdminTelemetriaRoute = AdminTelemetriaRouteImport.update({
            id: '/admin/telemetria',path: '/admin/telemetria',getParentRoute: () => rootRouteImport
          })
const AdminTransacoesRoute = AdminTransacoesRouteImport.update({
            id: '/admin/transacoes',path: '/admin/transacoes',getParentRoute: () => rootRouteImport
          })
const AdminUsuariosRoute = AdminUsuariosRouteImport.update({
            id: '/admin/usuarios',path: '/admin/usuarios',getParentRoute: () => rootRouteImport
          })
const CausaSlugRoute = CausaSlugRouteImport.update({
            id: '/causa/$slug',path: '/causa/$slug',getParentRoute: () => rootRouteImport
          })
const CausasIndexRoute = CausasIndexRouteImport.update({
            id: '/causas/',path: '/causas/',getParentRoute: () => rootRouteImport
          })
const CausasTrocarRoute = CausasTrocarRouteImport.update({
            id: '/causas/trocar',path: '/causas/trocar',getParentRoute: () => rootRouteImport
          })
const ComparadorDePrecosIndexRoute = ComparadorDePrecosIndexRouteImport.update({
            id: '/comparador-de-precos/',path: '/comparador-de-precos/',getParentRoute: () => rootRouteImport
          })
const ComparadorDePrecosIdRoute = ComparadorDePrecosIdRouteImport.update({
            id: '/comparador-de-precos/$id',path: '/comparador-de-precos/$id',getParentRoute: () => rootRouteImport
          })
const MarcaSlugRoute = MarcaSlugRouteImport.update({
            id: '/marca/$slug',path: '/marca/$slug',getParentRoute: () => rootRouteImport
          })
const MarcasIndexRoute = MarcasIndexRouteImport.update({
            id: '/marcas/',path: '/marcas/',getParentRoute: () => rootRouteImport
          })
const MarcasCategorySlugRoute = MarcasCategorySlugRouteImport.update({
            id: '/marcas/$categorySlug',path: '/marcas/$categorySlug',getParentRoute: () => rootRouteImport
          })
const OfertasIndexRoute = OfertasIndexRouteImport.update({
            id: '/ofertas/',path: '/ofertas/',getParentRoute: () => rootRouteImport
          })
const OfertasBuscaRoute = OfertasBuscaRouteImport.update({
            id: '/ofertas/busca',path: '/ofertas/busca',getParentRoute: () => rootRouteImport
          })
const ProdutoSlugRoute = ProdutoSlugRouteImport.update({
            id: '/produto/$slug',path: '/produto/$slug',getParentRoute: () => rootRouteImport
          })
const PromocoesSlugRoute = PromocoesSlugRouteImport.update({
            id: '/promocoes/$slug',path: '/promocoes/$slug',getParentRoute: () => rootRouteImport
          })
const AdminAiIndexRoute = AdminAiIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminAiRouteRoute
          })
const AdminAiSophiaRoute = AdminAiSophiaRouteImport.update({
            id: '/sophia',path: '/sophia',getParentRoute: () => AdminAiRouteRoute
          })
const AdminInternacionalIndexRoute = AdminInternacionalIndexRouteImport.update({
            id: '/admin/internacional/',path: '/admin/internacional/',getParentRoute: () => rootRouteImport
          })
const AdminInternacionalLojasRoute = AdminInternacionalLojasRouteImport.update({
            id: '/admin/internacional/lojas',path: '/admin/internacional/lojas',getParentRoute: () => rootRouteImport
          })
const AdminInternacionalPaisesRoute = AdminInternacionalPaisesRouteImport.update({
            id: '/admin/internacional/paises',path: '/admin/internacional/paises',getParentRoute: () => rootRouteImport
          })
const AdminInternacionalTraducoesRoute = AdminInternacionalTraducoesRouteImport.update({
            id: '/admin/internacional/traducoes',path: '/admin/internacional/traducoes',getParentRoute: () => rootRouteImport
          })
const AdminLojasIndexRoute = AdminLojasIndexRouteImport.update({
            id: '/admin/lojas/',path: '/admin/lojas/',getParentRoute: () => rootRouteImport
          })
const AdminLojasBrandIdRoute = AdminLojasBrandIdRouteImport.update({
            id: '/admin/lojas/$brandId',path: '/admin/lojas/$brandId',getParentRoute: () => rootRouteImport
          })
const AdminMarketingIndexRoute = AdminMarketingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminMarketingRouteRoute
          })
const AdminMarketingAutomacoesRoute = AdminMarketingAutomacoesRouteImport.update({
            id: '/automacoes',path: '/automacoes',getParentRoute: () => AdminMarketingRouteRoute
          })
const AdminMarketingBannersRoute = AdminMarketingBannersRouteImport.update({
            id: '/banners',path: '/banners',getParentRoute: () => AdminMarketingRouteRoute
          })
const AdminMarketingCarrosselRoute = AdminMarketingCarrosselRouteImport.update({
            id: '/carrossel',path: '/carrossel',getParentRoute: () => AdminMarketingRouteRoute
          })
const AdminMarketingNewsletterRoute = AdminMarketingNewsletterRouteImport.update({
            id: '/newsletter',path: '/newsletter',getParentRoute: () => AdminMarketingRouteRoute
          })
const AdminMarketingNotificacoesRoute = AdminMarketingNotificacoesRouteImport.update({
            id: '/notificacoes',path: '/notificacoes',getParentRoute: () => AdminMarketingRouteRoute
          })
const AdminMarketingSeloRoute = AdminMarketingSeloRouteImport.update({
            id: '/selo',path: '/selo',getParentRoute: () => AdminMarketingRouteRoute
          })
const AdminMarketingWhatsappRoute = AdminMarketingWhatsappRouteImport.update({
            id: '/whatsapp',path: '/whatsapp',getParentRoute: () => AdminMarketingRouteRoute
          })
const OfertasCategoriaIndexRoute = OfertasCategoriaIndexRouteImport.update({
            id: '/ofertas/$categoria/',path: '/ofertas/$categoria/',getParentRoute: () => rootRouteImport
          })
const OfertasCategoriaSubIndexRoute = OfertasCategoriaSubIndexRouteImport.update({
            id: '/ofertas/$categoria/$sub/',path: '/ofertas/$categoria/$sub/',getParentRoute: () => rootRouteImport
          })
const OfertasCategoriaSubPublicoRoute = OfertasCategoriaSubPublicoRouteImport.update({
            id: '/ofertas/$categoria/$sub/$publico',path: '/ofertas/$categoria/$sub/$publico',getParentRoute: () => rootRouteImport
          })





const AdminAiRouteRouteChildren = {
  AdminAiSophiaRoute: AdminAiSophiaRoute,AdminAiIndexRoute: AdminAiIndexRoute
}

const AdminAiRouteRouteWithChildren = AdminAiRouteRoute._addFileChildren(AdminAiRouteRouteChildren)




const AdminMarketingRouteRouteChildren = {
  AdminMarketingAutomacoesRoute: AdminMarketingAutomacoesRoute,AdminMarketingBannersRoute: AdminMarketingBannersRoute,AdminMarketingCarrosselRoute: AdminMarketingCarrosselRoute,AdminMarketingNewsletterRoute: AdminMarketingNewsletterRoute,AdminMarketingNotificacoesRoute: AdminMarketingNotificacoesRoute,AdminMarketingSeloRoute: AdminMarketingSeloRoute,AdminMarketingWhatsappRoute: AdminMarketingWhatsappRoute,AdminMarketingIndexRoute: AdminMarketingIndexRoute
}

const AdminMarketingRouteRouteWithChildren = AdminMarketingRouteRoute._addFileChildren(AdminMarketingRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SlugRoute: SlugRoute,AtivandoDoacaoRoute: AtivandoDoacaoRoute,BlogNewsRoute: BlogNewsRoute,CadastroRoute: CadastroRoute,ComoFuncionaRoute: ComoFuncionaRoute,ComoGeramosRoute: ComoGeramosRoute,CompletarPerfilRoute: CompletarPerfilRoute,ContatoRoute: ContatoRoute,CuponsDeDescontoRoute: CuponsDeDescontoRoute,DashboardRoute: DashboardRoute,EntrarParaAvaliarRoute: EntrarParaAvaliarRoute,EntrarParaDoarRoute: EntrarParaDoarRoute,FaqRoute: FaqRoute,LoginRoute: LoginRoute,PerfilRoute: PerfilRoute,PrivacidadeRoute: PrivacidadeRoute,RecuperarSenhaRoute: RecuperarSenhaRoute,RedefinirSenhaRoute: RedefinirSenhaRoute,SejaParceiroRoute: SejaParceiroRoute,SejaUmaMarcaDoBemRoute: SejaUmaMarcaDoBemRoute,SobreNosRoute: SobreNosRoute,TermosRoute: TermosRoute,UnsubscribeRoute: UnsubscribeRoute,AdminAiRouteRoute: AdminAiRouteRouteWithChildren,AdminMarketingRouteRoute: AdminMarketingRouteRouteWithChildren,AdminBlogRoute: AdminBlogRoute,AdminCategoriasRoute: AdminCategoriasRoute,AdminComparadorRoute: AdminComparadorRoute,AdminCuponsRoute: AdminCuponsRoute,AdminDisparosRoute: AdminDisparosRoute,AdminDoacoesRoute: AdminDoacoesRoute,AdminInstituicoesRoute: AdminInstituicoesRoute,AdminIntegracoesRoute: AdminIntegracoesRoute,AdminLocalizacaoRoute: AdminLocalizacaoRoute,AdminLocalizationRoute: AdminLocalizationRoute,AdminSaudeRoute: AdminSaudeRoute,AdminSeoRoute: AdminSeoRoute,AdminSyncRoute: AdminSyncRoute,AdminTelemetriaRoute: AdminTelemetriaRoute,AdminTransacoesRoute: AdminTransacoesRoute,AdminUsuariosRoute: AdminUsuariosRoute,CausaSlugRoute: CausaSlugRoute,CausasTrocarRoute: CausasTrocarRoute,ComparadorDePrecosIdRoute: ComparadorDePrecosIdRoute,MarcaSlugRoute: MarcaSlugRoute,MarcasCategorySlugRoute: MarcasCategorySlugRoute,OfertasBuscaRoute: OfertasBuscaRoute,ProdutoSlugRoute: ProdutoSlugRoute,PromocoesSlugRoute: PromocoesSlugRoute,AdminIndexRoute: AdminIndexRoute,CausasIndexRoute: CausasIndexRoute,ComparadorDePrecosIndexRoute: ComparadorDePrecosIndexRoute,MarcasIndexRoute: MarcasIndexRoute,OfertasIndexRoute: OfertasIndexRoute,AdminInternacionalLojasRoute: AdminInternacionalLojasRoute,AdminInternacionalPaisesRoute: AdminInternacionalPaisesRoute,AdminInternacionalTraducoesRoute: AdminInternacionalTraducoesRoute,AdminLojasBrandIdRoute: AdminLojasBrandIdRoute,AdminInternacionalIndexRoute: AdminInternacionalIndexRoute,AdminLojasIndexRoute: AdminLojasIndexRoute,OfertasCategoriaIndexRoute: OfertasCategoriaIndexRoute,OfertasCategoriaSubPublicoRoute: OfertasCategoriaSubPublicoRoute,OfertasCategoriaSubIndexRoute: OfertasCategoriaSubIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)